import React, { FC, useEffect, useState } from "react";

interface TimerProps {
  /** Время отсчета таймера */
  startTimestamp: number;
  /** Длительность таймера */
  timerDurationInMs: number;
  /** Функция, которая выполнится после окончания времени */
  onTimesUp?: () => void;
}

/** Таймер обратного отсчета */
export const Timer: FC<TimerProps> = ({ startTimestamp, timerDurationInMs: timerLengthInMs, onTimesUp }) => {
  const endTimestamp = startTimestamp + timerLengthInMs; 
  const [ms, setMs] = useState((endTimestamp - Date.now()));
  const timer = setTimeout(() => setMs(endTimestamp - Date.now()), 1000);
  const roundedSec = Math.ceil(ms/1000);

  let seconds = `${roundedSec % 60}`;
  if(seconds.length === 1) seconds = '0' + seconds;

  let minutes = `${Math.floor(roundedSec / 60)}`;
  if(minutes.length === 1) minutes = '0' + minutes;

  useEffect(() => {
    if(ms <= 0) {
      clearTimeout(timer);
      onTimesUp();
    }
  }, [ms]);

  return (
    <span>{`${minutes}:${seconds}`}</span>
  )
}